import { render, staticRenderFns } from "./RequisitionRowTabs.vue?vue&type=template&id=dabc4898&scoped=true"
import script from "./RequisitionRowTabs.vue?vue&type=script&lang=js"
export * from "./RequisitionRowTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dabc4898",
  null
  
)

export default component.exports